import { Injectable } from "@angular/core";
import { IID_EP_RICHIESTA_PERMESSO } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDEpRichiestaStore } from "./iidEPRichiesta.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
    providedIn: 'root'
  })
  @InterfaceDataQuery(InterfaceName.RICHIESTA_PERMESSO)
  export class IIDEpRichiestaQuery extends AbstractInterfaceDataQuery<IID_EP_RICHIESTA_PERMESSO> {
  
    constructor(protected store: IIDEpRichiestaStore) {
      super(store);
    }
  }